export default "__VITE_ASSET__cabc7fe7__"